export const selectLabel = "msVPBb";
export default {selectLabel};